export enum PresetKeyEnum {
  LastSevenDays = 'lastSevenDays',
  LastFourteenDays = 'lastFourteenDays',
  LastThirtyDays = 'lastThirtyDays',
  LastFortyFiveDays = 'lastFortyFiveDays',
  LastTwentyFourDays = 'lastTwentyFourDays',
  LastThirtyFourDays = 'lastThirtyFourDays',
  LastFourHours = 'lastFourHours',
  LastSixHours = 'lastSixHours',
  LastEightHours = 'lastEightHours',
  CurrentMonth = 'currentMonth',
  PreviousMonth = 'previousMonth',
  TwoMonthsPast = 'twoMonthsPast',
  ThreeMonthsPast = 'threeMonthsPast',
}

export const timePresetKeys = [
  PresetKeyEnum.LastFourHours,
  PresetKeyEnum.LastSixHours,
  PresetKeyEnum.LastEightHours,
  PresetKeyEnum.LastSevenDays,
  PresetKeyEnum.LastFourteenDays,
  PresetKeyEnum.LastTwentyFourDays,
];

export enum CCMAgentDashboardPresetKeyEnum {
  ThisWeek = 'thisWeek',
  NextWeek = 'nextWeek',
  CurrentMonth = 'currentMonth',
  PreviousMonth = 'previousMonth',
  TwoMonthsPast = 'twoMonthsPast',
  ThreeMonthsPast = 'threeMonthsPast',
}
